
/*


document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-frete-target]');
  if (!targets.length) return;

  const ENDPOINT = window.ALLPOST_ENDPOINT || '';
  const DEBUG = window.FRETE_DEBUG === true;

  const cache = new Map();

  function log(...args) {
    if (DEBUG) console.log('[FRETE]', ...args);
  }

  function sanitizeCep(cep) {
    return String(cep || '').replace(/\D/g, '');
  }

  function formatCep(cep) {
    const c = sanitizeCep(cep);
    return c.length === 8 ? c.replace(/(\d{5})(\d{3})/, '$1-$2') : '';
  }

  function getCep() {
    return sanitizeCep(localStorage.getItem('cliente_cep'));
  }

  function parseDate(dateString) {
    if (!dateString) return null;

    const normalized = String(dateString).length === 10
      ? `${dateString}T12:00:00`
      : dateString;

    const d = new Date(normalized);

    if (isNaN(d.getTime())) return null;

    return startOfDay(d);
  }

  function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function diffInDays(start, end) {
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round((startOfDay(end) - startOfDay(start)) / msPerDay);
  }

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;

      if (!isWeekend) {
        added++;
      }
    }

    return startOfDay(date);
  }

  function formatWeekday(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long'
    }).format(date).toLowerCase();
  }

  function formatDayMonth(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    }).format(date).toLowerCase();
  }

  function isSameDate(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function getNextOccurrenceOfWeekday(baseDate, targetWeekday) {
    const base = startOfDay(baseDate);
    const result = new Date(base);

    let diff = targetWeekday - base.getDay();

    if (diff <= 0) {
      diff += 7;
    }

    result.setDate(result.getDate() + diff);
    return startOfDay(result);
  }

  function buildDeliveryMessage(today, deliveryDate, originalCalendarDiff) {
    const deliveryWeekday = deliveryDate.getDay();

    const lightningIcon = originalCalendarDiff <= 3
      ? ` <span class="delivery-lightning" aria-label="fulfillment">
          <svg viewBox="0 0 24 24" role="img" focusable="false">
            <path d="M13 2L6 14h5l-1 8 8-12h-5l0-8z"></path>
          </svg>
        </span>`
      : '';

    if (originalCalendarDiff === 1) {
      return `${lightningIcon} Chegará amanhã`;
    }

    const nextImmediateWeekday = getNextOccurrenceOfWeekday(today, deliveryWeekday);

    if (isSameDate(deliveryDate, nextImmediateWeekday)) {
      return `${lightningIcon} Chegará até ${formatWeekday(deliveryDate)}`;
    }

    return `${lightningIcon} Chegará até ${formatWeekday(deliveryDate)}, ${formatDayMonth(deliveryDate)}`;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';

    let number = value;

    if (typeof number === 'string') {
      number = number
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    }

    number = Number(number);

    if (Number.isNaN(number)) return '';

    /*
      CarrierService da Shopify normalmente retorna em centavos:
      "27090" => R$ 270,90.
      Se vier como decimal pequeno, mantém:
      270.9 => R$ 270,90.
    */

    /*  
    if (number >= 1000) {
      number = number / 100;
    }

    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getRateCarrier(rate) {
    return (
      rate.service_name ||
      rate.name ||
      rate.title ||
      rate.description ||
      rate.dadosFrete?.transportadoraNome ||
      rate.transportadoraNome ||
      rate.transportadora ||
      'Entrega padrão'
    );
  }

  function getRatePrice(rate) {
    return (
      rate.price ||
      rate.total_price ||
      rate.original_price ||
      rate.freteCobrar ||
      rate.freteReal ||
      rate.valor ||
      rate.valorFrete ||
      rate.amount ||
      ''
    );
  }

  function getCacheKey(target, cep) {
    const sku = target.dataset.sku || '';
    return `${sku}_${cep}`;
  }

  function buildPayload(target, cep) {
    const sku = target.dataset.sku;
    if (!sku) return null;

    return {
      rate: {
        origin: {
          country: 'BR',
          postal_code: '01001-000',
          province: 'SP',
          city: 'São Paulo',
          name: null,
          address1: 'Rua Teste',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        destination: {
          country: 'BR',
          postal_code: formatCep(cep),
          province: '',
          city: '',
          name: 'Cliente',
          address1: '',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        items: [
          {
            name: target.dataset.productName,
            sku: sku,
            quantity: 1,
            grams: Number(target.dataset.grams || 0),
            price: Number(target.dataset.price || 0),
            vendor: target.dataset.vendor
          }
        ],
        currency: 'BRL',
        locale: 'pt-BR'
      }
    };
  }

  async function fetchFrete(payload) {
    log('Payload enviado:', payload);

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const text = await res.text();

    log('Status:', res.status);
    log('Resposta bruta:', text);

    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      log('Erro parse JSON');
    }

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return data;
  }

  function render(target, rate) {
    if (!rate || !rate.min_delivery_date) {
      target.textContent = 'Sem prazo';
      return;
    }

    const quotedMinDate = parseDate(rate.min_delivery_date);

    if (!quotedMinDate) {
      target.textContent = 'Prazo no checkout';
      return;
    }

    const today = startOfDay(new Date());
    const calendarDiff = diffInDays(today, quotedMinDate);
    const safeCalendarDiff = Math.max(calendarDiff, 0);
    const businessMinDate = addBusinessDays(today, safeCalendarDiff);

    const deliveryMessage = buildDeliveryMessage(today, businessMinDate, safeCalendarDiff);
    const carrier = getRateCarrier(rate);
    const price = formatMoney(getRatePrice(rate));

    target.innerHTML = `
      <div class="product-frete-result">
        <div class="product-frete-result__info">
          <div class="product-frete-result__carrier" style="display: none;">
            ${carrier}
          </div>

          <div class="product-frete-result__deadline">
            ${deliveryMessage}
          </div>
        </div>

        ${
          price
            ? `<div class="product-frete-result__price">${price}</div>`
            : ''
        }
      </div>
    `;
  }

  function renderError(target, error) {
    target.textContent = 'Erro frete';
    log('Erro:', error);
  }

  function renderLoading(target) {
    target.textContent = 'Consultando...';
  }

  async function update(target, cep) {
    if (!ENDPOINT) {
      target.textContent = 'Sem endpoint';
      return;
    }

    if (!cep || cep.length !== 8) {
      target.textContent = 'Informe seu CEP';
      return;
    }

    const key = getCacheKey(target, cep);

    if (cache.has(key)) {
      log('CACHE HIT:', key);
      const data = await cache.get(key);

      log('Rate cache:', data?.rates?.[0]);

      render(target, data?.rates?.[0]);
      return;
    }

    log('CACHE MISS:', key);

    const payload = buildPayload(target, cep);

    if (!payload) {
      target.textContent = 'Sem SKU';
      return;
    }

    renderLoading(target);

    const promise = fetchFrete(payload)
      .catch(err => {
        cache.delete(key);
        throw err;
      });

    cache.set(key, promise);

    try {
      const data = await promise;

      log('Rate:', data?.rates?.[0]);

      render(target, data?.rates?.[0]);
    } catch (e) {
      renderError(target, e);
    }
  }

  function run() {
    const cep = getCep();
    targets.forEach(t => update(t, cep));
  }

  run();

  document.addEventListener('cepAtualizado', () => {
    cache.clear();
    run();
  });
});

*/

/*

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-frete-target]');
  if (!targets.length) return;

  const ENDPOINT = window.ALLPOST_ENDPOINT || '';
  const DEBUG = window.FRETE_DEBUG === true;

  const cache = new Map();

  function log(...args) {
    if (DEBUG) console.log('[FRETE]', ...args);
  }

  function sanitizeCep(cep) {
    return String(cep || '').replace(/\D/g, '');
  }

  function formatCep(cep) {
    const c = sanitizeCep(cep);
    return c.length === 8 ? c.replace(/(\d{5})(\d{3})/, '$1-$2') : '';
  }

  function getCep() {
    return sanitizeCep(localStorage.getItem('cliente_cep'));
  }

  function parseDate(dateString) {
    if (!dateString) return null;

    const normalized = String(dateString).length === 10
      ? `${dateString}T12:00:00`
      : dateString;

    const d = new Date(normalized);

    if (isNaN(d.getTime())) return null;

    return startOfDay(d);
  }

  function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function diffInDays(start, end) {
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round((startOfDay(end) - startOfDay(start)) / msPerDay);
  }

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;

      if (!isWeekend) {
        added++;
      }
    }

    return startOfDay(date);
  }

  function formatWeekday(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long'
    }).format(date).toLowerCase();
  }

  function formatDayMonth(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    }).format(date).toLowerCase();
  }

  function isSameDate(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function getNextOccurrenceOfWeekday(baseDate, targetWeekday) {
    const base = startOfDay(baseDate);
    const result = new Date(base);

    let diff = targetWeekday - base.getDay();

    if (diff <= 0) {
      diff += 7;
    }

    result.setDate(result.getDate() + diff);
    return startOfDay(result);
  }

  function buildDeliveryMessage(today, deliveryDate, originalCalendarDiff) {
    const deliveryWeekday = deliveryDate.getDay();

    if (originalCalendarDiff === 1) {
      return 'Chega amanhã';
    }

    const nextImmediateWeekday = getNextOccurrenceOfWeekday(today, deliveryWeekday);

    if (isSameDate(deliveryDate, nextImmediateWeekday)) {
      return `Chega ${formatWeekday(deliveryDate)}`;
    }

    return `Chegará até ${formatWeekday(deliveryDate)}, ${formatDayMonth(deliveryDate)}`;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';

    let number = value;

    if (typeof number === 'string') {
      number = number
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    }

    number = Number(number);

    if (Number.isNaN(number)) return '';

    if (number >= 1000) {
      number = number / 100;
    }

    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getRateCarrier(rate) {
    return (
      rate.service_name ||
      rate.name ||
      rate.title ||
      rate.description ||
      rate.dadosFrete?.transportadoraNome ||
      rate.transportadoraNome ||
      rate.transportadora ||
      'Entrega padrão'
    );
  }

  function getRatePriceRaw(rate) {
    return (
      rate.price ??
      rate.total_price ??
      rate.original_price ??
      rate.freteCobrar ??
      rate.freteReal ??
      rate.valor ??
      rate.valorFrete ??
      rate.amount ??
      ''
    );
  }

  function normalizePriceNumber(value) {
    if (value === null || value === undefined || value === '') return null;

    let number = value;

    if (typeof number === 'string') {
      number = number
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    }

    number = Number(number);

    if (Number.isNaN(number)) return null;

    if (number >= 1000) {
      number = number / 100;
    }

    return number;
  }

  function isFreeShipping(rate) {
    const rawPrice = getRatePriceRaw(rate);
    const price = normalizePriceNumber(rawPrice);

    return price !== null && price <= 0;
  }

  function getCacheKey(target, cep) {
    const sku = target.dataset.sku || '';
    return `${sku}_${cep}`;
  }

  function buildPayload(target, cep) {
    const sku = target.dataset.sku;
    if (!sku) return null;

    return {
      rate: {
        origin: {
          country: 'BR',
          postal_code: '01001-000',
          province: 'SP',
          city: 'São Paulo',
          name: null,
          address1: 'Rua Teste',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        destination: {
          country: 'BR',
          postal_code: formatCep(cep),
          province: '',
          city: '',
          name: 'Cliente',
          address1: '',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        items: [
          {
            name: target.dataset.productName,
            sku: sku,
            quantity: 1,
            grams: Number(target.dataset.grams || 0),
            price: Number(target.dataset.price || 0),
            vendor: target.dataset.vendor
          }
        ],
        currency: 'BRL',
        locale: 'pt-BR'
      }
    };
  }

  async function fetchFrete(payload) {
    log('Payload enviado:', payload);

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const text = await res.text();

    log('Status:', res.status);
    log('Resposta bruta:', text);

    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      log('Erro parse JSON');
    }

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return data;
  }

  function render(target, rate) {
    if (!rate || !rate.min_delivery_date) {
      target.textContent = 'Sem prazo';
      return;
    }

    const quotedMinDate = parseDate(rate.min_delivery_date);

    if (!quotedMinDate) {
      target.textContent = 'Prazo no checkout';
      return;
    }

    const today = startOfDay(new Date());
    const calendarDiff = diffInDays(today, quotedMinDate);
    const safeCalendarDiff = Math.max(calendarDiff, 0);
    const businessMinDate = addBusinessDays(today, safeCalendarDiff);

    const isFastDelivery = safeCalendarDiff <= 2;
    const deliveryMessage = buildDeliveryMessage(today, businessMinDate, safeCalendarDiff);

    const carrier = getRateCarrier(rate);
    const rawPrice = getRatePriceRaw(rate);
    const price = formatMoney(rawPrice);
    const freeShipping = isFreeShipping(rate);

    target.innerHTML = `
      <div class="product-frete-result ${isFastDelivery ? 'product-frete-result--fast' : 'product-frete-result--normal'} ${freeShipping ? 'product-frete-result--free' : 'product-frete-result--paid'}">
        <div class="product-frete-result__info">
          <div class="product-frete-result__carrier">
            ${carrier}
          </div>

          <div class="product-frete-result__deadline">
            ${deliveryMessage}
          </div>
        </div>

        <div class="product-frete-result__price">
          ${freeShipping ? 'Frete grátis' : price}
        </div>
      </div>
    `;
  }

  function renderError(target, error) {
    target.textContent = 'Erro frete';
    log('Erro:', error);
  }

  function renderLoading(target) {
    target.textContent = 'Consultando...';
  }

  async function update(target, cep) {
    if (!ENDPOINT) {
      target.textContent = 'Sem endpoint';
      return;
    }

    if (!cep || cep.length !== 8) {
      target.textContent = 'Informe seu CEP';
      return;
    }

    const key = getCacheKey(target, cep);

    if (cache.has(key)) {
      log('CACHE HIT:', key);
      const data = await cache.get(key);
      log('Rate cache:', data?.rates?.[0]);
      render(target, data?.rates?.[0]);
      return;
    }

    log('CACHE MISS:', key);

    const payload = buildPayload(target, cep);

    if (!payload) {
      target.textContent = 'Sem SKU';
      return;
    }

    renderLoading(target);

    const promise = fetchFrete(payload)
      .catch(err => {
        cache.delete(key);
        throw err;
      });

    cache.set(key, promise);

    try {
      const data = await promise;
      log('Rate:', data?.rates?.[0]);
      render(target, data?.rates?.[0]);
    } catch (e) {
      renderError(target, e);
    }
  }

  function run() {
    const cep = getCep();
    targets.forEach(t => update(t, cep));
  }

  run();

  document.addEventListener('cepAtualizado', () => {
    cache.clear();
    run();
  });
});

*/

document.addEventListener('DOMContentLoaded', () => {
  let targets = document.querySelectorAll('[data-frete-target]');

  const ENDPOINT = window.ALLPOST_ENDPOINT || '';
  const DEBUG = window.FRETE_DEBUG === true;

  const cache = new Map();
  let observerTimer = null;

  function log(...args) {
    if (DEBUG) console.log('[FRETE]', ...args);
  }

  function sanitizeCep(cep) {
    return String(cep || '').replace(/\D/g, '');
  }

  function formatCep(cep) {
    const c = sanitizeCep(cep);
    return c.length === 8 ? c.replace(/(\d{5})(\d{3})/, '$1-$2') : '';
  }

  function getCep() {
    return sanitizeCep(localStorage.getItem('cliente_cep'));
  }

  function parseDate(dateString) {
    if (!dateString) return null;

    const normalized = String(dateString).length === 10
      ? `${dateString}T12:00:00`
      : dateString;

    const d = new Date(normalized);

    if (isNaN(d.getTime())) return null;

    return startOfDay(d);
  }

  function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function diffInDays(start, end) {
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round((startOfDay(end) - startOfDay(start)) / msPerDay);
  }

  function addBusinessDays(startDate, days) {
    const date = new Date(startDate);
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;

      if (!isWeekend) {
        added++;
      }
    }

    return startOfDay(date);
  }

  function formatWeekday(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      weekday: 'long'
    }).format(date).toLowerCase();
  }

  function formatDayMonth(date) {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    }).format(date).toLowerCase();
  }

  function isSameDate(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function getNextOccurrenceOfWeekday(baseDate, targetWeekday) {
    const base = startOfDay(baseDate);
    const result = new Date(base);

    let diff = targetWeekday - base.getDay();

    if (diff <= 0) {
      diff += 7;
    }

    result.setDate(result.getDate() + diff);
    return startOfDay(result);
  }

  function buildDeliveryMessage(today, deliveryDate, originalCalendarDiff) {
    const deliveryWeekday = deliveryDate.getDay();

    if (originalCalendarDiff === 1) {
      return 'Chegará até amanhã';
    }

    const nextImmediateWeekday = getNextOccurrenceOfWeekday(today, deliveryWeekday);

    if (isSameDate(deliveryDate, nextImmediateWeekday)) {
      return `Chegará até ${formatWeekday(deliveryDate)}`;
    }

    return `Chegará até ${formatWeekday(deliveryDate)}, ${formatDayMonth(deliveryDate)}`;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';

    let number = value;

    if (typeof number === 'string') {
      number = number
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    }

    number = Number(number);

    if (Number.isNaN(number)) return '';

    if (number >= 1000) {
      number = number / 100;
    }

    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getRateCarrier(rate) {
    return (
      rate.service_name ||
      rate.name ||
      rate.title ||
      rate.description ||
      rate.dadosFrete?.transportadoraNome ||
      rate.transportadoraNome ||
      rate.transportadora ||
      'Entrega padrão'
    );
  }

  function getRatePriceRaw(rate) {
    return (
      rate.price ??
      rate.total_price ??
      rate.original_price ??
      rate.freteCobrar ??
      rate.freteReal ??
      rate.valor ??
      rate.valorFrete ??
      rate.amount ??
      ''
    );
  }

  function normalizePriceNumber(value) {
    if (value === null || value === undefined || value === '') return null;

    let number = value;

    if (typeof number === 'string') {
      number = number
        .replace('R$', '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
    }

    number = Number(number);

    if (Number.isNaN(number)) return null;

    if (number >= 1000) {
      number = number / 100;
    }

    return number;
  }

  function isFreeShipping(rate) {
    const rawPrice = getRatePriceRaw(rate);
    const price = normalizePriceNumber(rawPrice);

    return price !== null && price <= 0;
  }

  function getCacheKey(target, cep) {
    const sku = target.dataset.sku || '';
    return `${sku}_${cep}`;
  }

  function buildPayload(target, cep) {
    const sku = target.dataset.sku;
    if (!sku) return null;

    return {
      rate: {
        origin: {
          country: 'BR',
          postal_code: '01001-000',
          province: 'SP',
          city: 'São Paulo',
          name: null,
          address1: 'Rua Teste',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        destination: {
          country: 'BR',
          postal_code: formatCep(cep),
          province: '',
          city: '',
          name: 'Cliente',
          address1: '',
          address2: '',
          address3: null,
          phone: null,
          fax: null,
          email: null
        },
        items: [
          {
            name: target.dataset.productName,
            sku: sku,
            quantity: 1,
            grams: Number(target.dataset.grams || 0),
            price: Number(target.dataset.price || 0),
            vendor: target.dataset.vendor
          }
        ],
        currency: 'BRL',
        locale: 'pt-BR'
      }
    };
  }

  async function fetchFrete(payload) {
    log('Payload enviado:', payload);

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const text = await res.text();

    log('Status:', res.status);
    log('Resposta bruta:', text);

    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {
      log('Erro parse JSON');
    }

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    return data;
  }
  /*

  function render(target, rate) {
    if (!rate || !rate.min_delivery_date) {
      target.textContent = 'Sem prazo';
      return;
    }

    const quotedMinDate = parseDate(rate.min_delivery_date);

    if (!quotedMinDate) {
      target.textContent = 'Prazo no checkout';
      return;
    }

    const today = startOfDay(new Date());
    const calendarDiff = diffInDays(today, quotedMinDate);
    const safeCalendarDiff = Math.max(calendarDiff, 0);
    const businessMinDate = addBusinessDays(today, safeCalendarDiff);

    const isFastDelivery = safeCalendarDiff <= 2;
    const deliveryMessage = buildDeliveryMessage(today, businessMinDate, safeCalendarDiff);

    const carrier = getRateCarrier(rate);
    const rawPrice = getRatePriceRaw(rate);
    const price = formatMoney(rawPrice);
    const freeShipping = isFreeShipping(rate);

    target.innerHTML = `
      <div class="product-frete-result ${isFastDelivery ? 'product-frete-result--fast' : 'product-frete-result--normal'} ${freeShipping ? 'product-frete-result--free' : 'product-frete-result--paid'}">
        <div class="product-frete-result__info">
          <div class="product-frete-result__carrier">
            ${carrier}
          </div>

          <div class="product-frete-result__deadline">
            ${deliveryMessage}
          </div>
        </div>

        <div class="product-frete-result__price">
          ${freeShipping ? 'Frete grátis' : price}
        </div>
      </div>
    `;
  }
    */

  function render(target, rate) {
  const card =
    target.closest('.product-card') ||
    target.closest('.product-item') ||
    target.closest('[class*="product-card"]');

  const badge = card?.querySelector('.js-frete-gratis-badge');

  if (!rate || !rate.min_delivery_date) {
    if (badge) badge.hidden = true;
    target.textContent = 'Sem prazo';
    return;
  }

  const quotedMinDate = parseDate(rate.min_delivery_date);

  if (!quotedMinDate) {
    if (badge) badge.hidden = true;
    target.textContent = 'Prazo no checkout';
    return;
  }

  const today = startOfDay(new Date());
  const calendarDiff = diffInDays(today, quotedMinDate);
  const safeCalendarDiff = Math.max(calendarDiff, 0);
  const businessMinDate = addBusinessDays(today, safeCalendarDiff);

  const isFastDelivery = safeCalendarDiff <= 2;
  const deliveryMessage = buildDeliveryMessage(today, businessMinDate, safeCalendarDiff);

  const carrier = getRateCarrier(rate);
  const rawPrice = getRatePriceRaw(rate);
  const price = formatMoney(rawPrice);
  const freeShipping = isFreeShipping(rate);

  if (badge) {
    badge.hidden = !freeShipping;
  }

  target.innerHTML = `
    <div class="product-frete-result ${isFastDelivery ? 'product-frete-result--fast' : 'product-frete-result--normal'} ${freeShipping ? 'product-frete-result--free' : 'product-frete-result--paid'}">
      <div class="product-frete-result__info">
        <div class="product-frete-result__carrier">
          ${carrier}
        </div>

        <div class="product-frete-result__deadline">
          ${deliveryMessage}
        </div>
      </div>

      <div class="product-frete-result__price">
        ${freeShipping ? 'Frete grátis' : price}
      </div>
    </div>
  `;
}

  function renderError(target, error) {
    target.textContent = 'Não foi possível calcular o frete agora. Tente novamente em alguns instantes.';
    log('Erro:', error);
  }

  function renderLoading(target) {
    target.textContent = 'Consultando...';
  }

  async function update(target, cep, force = false) {
    if (!ENDPOINT) {
      target.textContent = 'Sem endpoint';
      return;
    }

    /* informe o cep card */

    if (!cep || cep.length !== 8) {
      target.textContent = '';
      return;
    }

    if (target.dataset.freteLoaded === 'true' && !force) {
      return;
    }

    target.dataset.freteLoaded = 'true';

    const key = getCacheKey(target, cep);

    if (cache.has(key)) {
      log('CACHE HIT:', key);
      const data = await cache.get(key);
      log('Rate cache:', data?.rates?.[0]);
      render(target, data?.rates?.[0]);
      return;
    }

    log('CACHE MISS:', key);

    const payload = buildPayload(target, cep);

    if (!payload) {
      target.textContent = 'Sem SKU';
      return;
    }

    renderLoading(target);

    const promise = fetchFrete(payload)
      .catch(err => {
        cache.delete(key);
        throw err;
      });

    cache.set(key, promise);

    try {
      const data = await promise;
      log('Rate:', data?.rates?.[0]);
      render(target, data?.rates?.[0]);
    } catch (e) {
      renderError(target, e);
    }
  }

  function run(force = false) {
    targets = document.querySelectorAll('[data-frete-target]');

    if (!targets.length) return;

    const cep = getCep();

    targets.forEach(target => {
      update(target, cep, force);
    });
  }

  window.atualizarFreteCards = function () {
    targets = document.querySelectorAll('[data-frete-target]');

    targets.forEach(target => {
      delete target.dataset.freteLoaded;
    });

    cache.clear();
    run(true);
  };

  function scheduleRunForNewCards() {
    clearTimeout(observerTimer);

    observerTimer = setTimeout(() => {
      const cep = getCep();

      if (cep.length !== 8) return;

      const newTargets = Array.from(document.querySelectorAll('[data-frete-target]'))
        .filter(target => target.dataset.freteLoaded !== 'true');

      if (!newTargets.length) return;

      newTargets.forEach(target => {
        update(target, cep);
      });
    }, 250);
  }

  const observer = new MutationObserver((mutations) => {
    const hasRelevantChange = mutations.some(mutation => {
      return Array.from(mutation.addedNodes).some(node => {
        if (!(node instanceof HTMLElement)) return false;

        return (
          node.matches?.('[data-frete-target]') ||
          node.querySelector?.('[data-frete-target]')
        );
      });
    });

    if (hasRelevantChange) {
      scheduleRunForNewCards();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  run();

  window.addEventListener('load', () => {
    scheduleRunForNewCards();
  });

  document.addEventListener('cepAtualizado', () => {
    window.atualizarFreteCards();
  });

  document.addEventListener('shopify:section:load', () => {
    window.atualizarFreteCards();
  });

  document.addEventListener('theme:loading:end', () => {
    window.atualizarFreteCards();
  });

  document.addEventListener('facet:updated', () => {
    window.atualizarFreteCards();
  });

  document.addEventListener('collection:updated', () => {
    window.atualizarFreteCards();
  });
});